import { render, staticRenderFns } from "./ValueChangeField.vue?vue&type=template&id=80635b18&scoped=true&"
import script from "./ValueChangeField.vue?vue&type=script&lang=js&"
export * from "./ValueChangeField.vue?vue&type=script&lang=js&"
import style0 from "./ValueChangeField.vue?vue&type=style&index=0&id=80635b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80635b18",
  null
  
)

export default component.exports
import {QField,QInput} from 'quasar'
component.options.components = Object.assign({QField,QInput}, component.options.components || {})
